import type { PaginationType } from '../types/Pagination.types';
import type { ProviderDto, ProviderListParams } from './providers.schema';

import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { ProviderDtoSchema, ProviderParamsSchema } from './providers.schema';

export const providersApi = {
  async getAll(params?: ProviderListParams) {
    const validatedParams = params ? validateWithZod(ProviderParamsSchema, params) : undefined;

    const response = await httpClient.get<PaginationType<ProviderDto>>(
      ENDPOINTS.providers.all,
      { params: validatedParams },
    );

    return validateWithZod(PaginationSchema(ProviderDtoSchema), response);
  },

  async getByIdOrAlias(idOrAlias: string) {
    const response = await httpClient.get<ProviderDto>(ENDPOINTS.providers.byId(idOrAlias));

    return validateWithZod(ProviderDtoSchema, response);
  },
};
